import React from "react";
import styled from "styled-components";
import { Button, Col, Form, Row, Select, Input, DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/zh_TW";
import { contractModeFilterOptions, contractStatusOptions } from "./utils";

const { RangePicker } = DatePicker;

const Wrapper = styled(Form)<{ isVisible: boolean }>`
  padding: 24px 16px 16px 16px;
  background: #ffffff;
  border-radius: 2px;
  margin-bottom: 16px;
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
`;

const CustomButton = styled(Button)`
  margin-right: 10px;
`;

interface FilterProps {
  onSubmit: (values: any) => void;
  onReset: () => void;
  isVisible: boolean;
}

export default function Filter(props: FilterProps) {
  const { onSubmit, onReset, isVisible } = props;
  const [form] = Form.useForm();

  const handleReset = () => {
    form.resetFields();
    onReset();
  };

  const handleSubmit = (values: any) => {
    onSubmit(values);
  };

  return (
    <Wrapper
      form={form}
      labelCol={{ span: 7 }}
      labelAlign="left"
      colon={false}
      onFinish={handleSubmit}
      isVisible={isVisible}
    >
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="統一編號" name="ubn">
            <Input placeholder="請輸入統一編號" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="廠商名稱" name="name">
            <Input placeholder="請輸入廠商名稱" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="合作類型" name="contractMode">
            <Select placeholder="請選擇合作類型" allowClear options={contractModeFilterOptions} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="狀態" name="status">
            <Select placeholder="請選擇狀態" allowClear options={contractStatusOptions} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="合約生效日" name="startDate">
            <RangePicker locale={locale} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="end">
        <Col span={8}>
          <Row justify="end">
            <CustomButton onClick={handleReset}>清除篩選條件</CustomButton>
            <Button type="primary" htmlType="submit">
              套用
            </Button>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
}
